// extracted by mini-css-extract-plugin
export default {"summary":"TaskPermissionPage_summary__bc5Op","title":"TaskPermissionPage_title__8rPAp"};